import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  PostTmiTestConnectionQuery,
  TmiTestConnectionSuccessResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (response: TmiTestConnectionSuccessResponse) => ReactElement
  onSuccess?: (notificationSettings: TmiTestConnectionSuccessResponse) => void
  onError?: (error: Error) => void
  params?: PostTmiTestConnectionQuery
}

const TestTmiConnectionRequest = ({
  children,
  onSuccess,
  onError,
  params
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/integrations/test`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default TestTmiConnectionRequest
